import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            light: '#fff',
            main: '#343434',
            dark: '#e8322e'
        },
        secondary: {
            main: '#e8322e',
            light: '#D9D9D9',
            dark: '#000'
        },
        text: {
            primary: '#5d5d5d',
            secondary: '#fff',
        }
    }
});

export default theme;